import http from './http-common';

class FabricTypeService {
  getAll() {
    return http.get('/fabricType');
  }
  getFabricTypeForList() {
    return http.get('fabricType/getFabricTypeForList');
  }
  get(id) {
    return http.get(`/fabricType/${id}`);
  }
  
  create(data) {
    return http.post(`/fabricType/add`, data);
  }

  update(data) {
    console.log('data: ', data);
    return http.put(`/fabricType/update`, data);
  }
}

export default new FabricTypeService();
